import { useQuery, QueryResult } from '@apollo/client';
// Api
import { ME } from 'api/auth/queries';
// Types
import { Me } from 'api/auth/types/Me';
// Hooks
import { useAppContext } from 'hooks';

export const useGetCurrUser = (options?: {
  skip?: boolean;
}): QueryResult<Me> => {
  const { token: contextToken } = useAppContext();
  const skip = !contextToken || options?.skip;

  const data = useQuery<Me>(ME, {
    skip: skip,
    fetchPolicy: 'network-only', // Always fetch fresh auth data
    nextFetchPolicy: 'cache-first', // Use cache for subsequent requests
  });

  return data;
};
